<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="visible" ref="modal">
        <div class="layer-card"></div>   
        <div class="u-window card-modal needLang hyz">           
            <div class="u-btn close" @click="destroyElement"></div>
            <div class="dialog-content">
                <div class="dialog-wrapper">
                    <h5 class="title"></h5>

                    <div class="card-view">
                        <div class="card-content">
                            <div class="text">
                                {{ card.content }}
                            </div>
                            <div class="u-btn send copy" v-if="isCopy" @click="copy" data-clipboard-action="copy" :data-clipboard-text="shareTxt"></div>
                        </div>
                        <div class="card-label">
                            <div class="label">
                                {{ card.theme }}
                            </div>
                        </div>                        
                    </div>

                    <div class="u-btn card-apply" @click="destroyElement" v-if="type=='result'"></div>
                    <div class="u-btn modal-close" @click="destroyElement" v-else></div>
                </div> 
            </div>     
        </div> 
        
        <div class="u-mask"></div>
    </div>
</transition>      
</template>

<script>
export default {
    data(){
        return {
            visible : false,
            card : { },
            type : 'detail',//detail result
            shareTxt : '分享专属链接 开启助力',
            isCopy : true,
        }
    },
    created (){
        document.body.style.overflow = 'hidden';
    },  
    methods : {
        destroyElement () {
            document.body.style.overflow = ''; // 出现滚动条
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },
        copy() {
            //复制链接
            let _this = this;
            let clipboard = new _this.clipboard(".copy");
            clipboard.on('success', function () {
              clipboard.destroy();
              _this.$toast("复制分享链接成功！去微信/QQ粘贴与好友互赠~");
              _this.destroyElement();
            });
            clipboard.on('error', function () {
              clipboard.destroy()
              _this.$toast("复制失败");
            });
            //_this.destroyElement();
        },             
    },    
}
</script>

<style lang="scss" scoped>
.card-modal{
    position: relative;
    margin-top: -100px;
}

.layer-card{
    position: absolute;
    left: 50%;
    top: 50%;
    width: 664px;
    height: 424px;
    transform: translate(-50%,-50%);
    margin-top: -100px;
    background-image: url(~@/assets/images/modal/layer-card.png);
    z-index: 30;
}

.title{
    width: 457px;
    height: 68px;
    margin: 0 auto 70px;
    background-image: url(~@/assets/images/modal/title-result.png);
}

.u-btn.close{
    right: -30px;
}

.card-view{
    position: relative;
    width: 595px;

    .card-content{
        position: relative;
        width: 550px;
        height: 410px;
        background-image: url(~@/assets/images/modal/bg-card-content.png);

        .text{
            padding: 80px 25px 0 260px;
            color: #c53a1e;
            line-height: 1.6;
            font-size: 32px;
        }

        .u-btn.send{
            position: absolute;
            right: 60px;
            bottom: 46px;
            width: 134px;
            height: 52px;
            background-image: url(~@/assets/images/modal/btn-card_send.png);
        }
    }

    .card-label{
        position: absolute;
        left: 0;
        top: 58%;
        transform: translateY(-50%);
        width: 215px;
        height: 506px;
        background-image: url(~@/assets/images/modal/bg-card-label.png);
        
        .label{
            width: 60px;
            line-height: 60px;
            color: #ffe56c;
            font-size: 60px;
            position: absolute;
            top: 40%;
            left: 50%;
            transform: translate(-50%,-50%);                 
        }        
    }
}

.u-btn.modal-close{
    width: 282px;
    height: 78px;
    margin: 105px auto 0;
    background-image: url(~@/assets/images/modal/btn-card_close.png);
}

.u-btn.card-apply{
    width: 282px;
    height: 78px;
    margin: 105px auto 0;
    background-image: url(~@/assets/images/modal/btn-card_apply.png);
}
</style>